import { Box, useTheme } from '@mui/material';
import { t } from 'i18next';
import { useCreateCallback } from 'json-api-hooks';
import React, { FC } from 'react';

import Button from '../../components/././Button';
import { EventResource } from '../../models';

const noticeStyle = {
  background: '#f8f8f8',
  border: '1px solid #e6e6e6',
  display: 'inline-block',
  flexGrow: 1,
  fontFamily: 'Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif',
  fontSize: '1em',
  margin: 0,
  padding: '0.5rem 1.3rem',
  textTransform: 'unset',
  transition: 'box-shadow .1s,background-color .1s',
  whiteSpace: 'nowrap',
};

const EventSignUpButton: FC<{ event: EventResource }> = ({ event }) => {
  const theme = useTheme();
  const signedUp = !!event.attributes.userParticipantId;
  const [createCallback, createLoading] = useCreateCallback('participants');

  if (signedUp) {
    return <Box sx={noticeStyle}>{t('events.status.signedUp')}</Box>;
  }

  const date = new Date(event.attributes.endsAt ?? event.attributes.happensAt);
  const expired = date < new Date();
  const full =
    event.attributes.desiredCount !== 0 && event.attributes.participantsCount >= event.attributes.desiredCount;

  if (expired || full) {
    return <Box sx={noticeStyle}>{t('events.status.full')}</Box>;
  }

  return (
    <Button
      color={theme.palette.primary.main}
      icon="hand-o-up"
      loading={createLoading}
      variant="outlined"
      onClick={() => createCallback({ eventId: event.id }).catch(() => {})}
    >
      Ik doe mee!
    </Button>
  );
};

export default EventSignUpButton;
